function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import Donut from '../Donut';
import { getValidElementProps } from '../utils/htmlValidProps';

var ProgressCircle = function ProgressCircle(props) {
  var className = props.className,
      value = props.value,
      label = props.label,
      labelComponent = props.labelComponent,
      colors = props.colors,
      min = props.min,
      max = props.max,
      lineWidth = props.lineWidth;
  var divProps = getValidElementProps('div', props);
  return /*#__PURE__*/React.createElement(Donut, _extends({
    data: [{
      label: label,
      value: value
    }, {
      label: 'Remaining',
      value: max - value
    }],
    groupBy: "percentage",
    customLabel: function customLabel() {
      return labelComponent({
        value: value,
        label: label,
        colors: colors,
        min: min,
        max: max
      });
    },
    colors: colors,
    label: label,
    lineWidth: lineWidth,
    role: "progressbar",
    "aria-valuemin": min,
    "aria-valuenow": value,
    "aria-valuemax": max
  }, divProps));
};

var DefaultLabelComponent = function DefaultLabelComponent(props) {
  return /*#__PURE__*/React.createElement("text", {
    dy: "12",
    alignmentBaseline: "middle",
    textAnchor: "middle",
    className: "donut__centerlabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    dx: ".1em",
    className: "donut__centerlabel__value"
  }, props.value, /*#__PURE__*/React.createElement("tspan", {
    dx: "-0.05em",
    dy: "-1.1em",
    className: "centerlabel__value__icon"
  }, "%")), /*#__PURE__*/React.createElement("tspan", {
    x: "0",
    dy: "2.75em",
    className: "donut__centerlabel__subtext"
  }, props.label));
};

ProgressCircle.defaultProps = {
  className: '',
  label: 'Complete',
  labelComponent: DefaultLabelComponent,
  colors: ['#02a0aa', '#b1b1b1'],
  min: 0,
  max: 100,
  tabIndex: 0
};
ProgressCircle.propTypes = {
  /** Additional classes */
  className: PropTypes.string,

  /** The progress value to be displayed */
  value: PropTypes.number.isRequired,

  /** The label text to display */
  label: PropTypes.string,

  /** If needed, a custom label component can be passed */
  labelComponent: PropTypes.func,

  /** an array of colors for each arc */
  colors: PropTypes.array,

  /** Minmum progress */
  min: PropTypes.number,

  /** Maximum progress */
  max: PropTypes.number,

  /** The line width of the underlying donut chart */
  lineWidth: PropTypes.number,
  tabIndex: PropTypes.number
};
ProgressCircle.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProgressCircle",
  "props": {
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Additional classes"
    },
    "label": {
      "defaultValue": {
        "value": "'Complete'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The label text to display"
    },
    "labelComponent": {
      "defaultValue": {
        "value": "props => (\n  <text dy='12' alignmentBaseline='middle' textAnchor='middle' className='donut__centerlabel'>\n    <tspan dx='.1em' className='donut__centerlabel__value'>\n      {/* eslint-disable-next-line react/destructuring-assignment, react/prop-types */}\n      {props.value}\n      <tspan dx='-0.05em' dy='-1.1em' className='centerlabel__value__icon'>\n        %\n      </tspan>\n    </tspan>\n    <tspan x='0' dy='2.75em' className='donut__centerlabel__subtext'>\n      {/* eslint-disable-next-line react/destructuring-assignment, react/prop-types */}\n      {props.label}\n    </tspan>\n  </text>\n)",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "If needed, a custom label component can be passed"
    },
    "colors": {
      "defaultValue": {
        "value": "['#02a0aa', '#b1b1b1']",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": "an array of colors for each arc"
    },
    "min": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Minmum progress"
    },
    "max": {
      "defaultValue": {
        "value": "100",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Maximum progress"
    },
    "tabIndex": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "number"
      },
      "required": true,
      "description": "The progress value to be displayed"
    },
    "lineWidth": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "The line width of the underlying donut chart"
    }
  }
};
export default ProgressCircle;